module.exports = __webpack_public_path__ + "img/6.82306ce2.jpg";